import { useLocation } from '@reach/router';
import { graphql } from 'gatsby';
import React, { useEffect, useRef, useState } from 'react';

import './readMore.scss';

interface ReadMoreProps {
    text: string;
}

export const query = graphql`
    fragment ReadMoreBlock on WpAcfReadmoreBlock {
        AcfBlockReadMore {
            text
        }
    }
`;

const ReadMore = (props: ReadMoreProps) => {
    const location = useLocation();
    // states
    const [activeHeight, setActiveHeight] = useState<Number>(0);
    const [expanded, setExpanded] = useState<boolean>(false);

    // refs
    const innerRef = useRef<HTMLDivElement>(null);
    const mainRef = useRef<HTMLDivElement>(null);

    const handleExpand = () => {
        setExpanded(!expanded);
    };

    // set active height on win resize
    useEffect(() => {
        const handleResize = () => {
            innerRef.current && setActiveHeight(innerRef.current.clientHeight + 16);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div ref={mainRef} className={`readmore ${expanded ? 'expanded' : ''}`}>
            <div className="readmore-text typo-h-redline">
                <div className="readmore-text-inner collapse" style={{ height: expanded ? `${activeHeight}px` : '0' }}>
                    <div ref={innerRef} dangerouslySetInnerHTML={{ __html: props.text }} />
                </div>
            </div>
            <div className="readmore-button-container">
                <button className="readmore-button link-text" onClick={handleExpand}>
                    <span>Weiterlesen</span>
                    <span>Schliessen</span>
                </button>
            </div>
        </div>
    );
};

export default ReadMore;
